module.exports = __webpack_public_path__ + "static/media/comment-alt-exclamation.ecb7828f.svg";